import React from "react";
import {Navigate, useNavigate, useParams, useLocation} from "react-router-dom";
import type {SubtaskStatus} from "../../types/plan-sub-task.ts";
import SubtaskDetail from "./SubtaskDetail.tsx";

const SubtaskDetailWrapper: React.FC = () => {
    const { code } = useParams<{ code: string }>();
    const navigate = useNavigate();
    const location = useLocation();

    if (!code) {
        return <Navigate to="/subtasks" replace />;
    }

    const handleBack = () => {
        // 检查来源页面，根据来源返回到对应的列表页面
        const from = location.state?.from;
        
        if (from === '/subtasks4Worker') {
            navigate('/subtasks4Worker');
        } else {
            // 默认返回到管理员列表页面
            navigate('/subtasks');
        }
    };

    const handleStatusChange = (newStatus: SubtaskStatus) => {
        console.log('Status change:', newStatus);
        // Will be implemented in later tasks
    };

    return (
        <SubtaskDetail
            subtaskCode={code}
            onBack={handleBack}
            onStatusChange={handleStatusChange}
        />
    );
};

export default SubtaskDetailWrapper;